<template>
  <div class="page">
    <div class="page__bd">
      <div class="weui-cells__title">
        <span>请选择其中一种方式帮助您修改密码</span>
      </div>
      <div class="weui-cells">
        <router-link
          class="weui-cell weui-cell_access"
          :to="'/security/reset_by_pass?mobile='+account.mobile"
        >
          <div class="weui-cell__hd">
            <span class="iconfont icon-password"></span>
          </div>
          <div class="weui-cell__bd">
            <p>通过密码验证</p>
          </div>
          <div class="weui-cell__ft"></div>
        </router-link>
        <router-link
          class="weui-cell weui-cell_access"
          :to="'/security/reset_by_mobile?mobile='+account.mobile"
        >
          <div class="weui-cell__hd">
            <span class="iconfont icon-mobile"></span>
          </div>
          <div class="weui-cell__bd">
            <p>通过手机验证</p>
          </div>
          <div class="weui-cell__ft"></div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import Auth from "@/util/auth.js";

export default {
  data() {
    return {
      account: {}
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.loadData();
    });
  },
  methods: {
    loadData() {
      var me = this;
      Auth.get()
        .then(function(data) {
          me.account = data.account;
        })
        .catch(function(res) {
          me.$router.push({
            name: "Error",
            params: res
          });
        });
    }
  }
};
</script>